<template>
    <div class="settlement" >
        <main class="content">
            <el-card>
                <el-form :inline="true" :model="searchForm" :disabled="loading" size="mini">
                    <el-form-item label="公司名称" prop="companyIds" label-width="70px"  >
                        <el-select filterable  collapse-tags clearable size="mini" mul v-model="searchForm.companyId" placeholder="公司名称"  style="width: 200px">
                            <el-option
                                v-for="item in companys"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="销售订单" label-width="70px">
                        <el-input v-model="searchForm.settlementNo" placeholder="销售订单" size="mini" clearable
                            style="width: 150px"></el-input>
                    </el-form-item>
                    <el-form-item label="子订单" label-width="70px">
                        <el-input v-model="searchForm.orderNo" placeholder="子订单" size="mini" clearable
                            style="width: 150px"></el-input>
                    </el-form-item>
                    <el-form-item label="SKU" label-width="70px">
                        <el-input v-model="searchForm.sku" placeholder="SKU" size="mini" clearable
                            style="width: 150px"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="doSearch()" size="mini">查询</el-button>
                    </el-form-item>
                    <el-form-item>
                        <RightToolBar :showSearch="showSearch"  @reDrawTable="reDrawTable"
                                      :columns="dropCol" ></RightToolBar>
                    </el-form-item>
            </el-form>
                <div ref="tablePosition"></div>
                <el-table
                    :key = "updateTable"
                    row-key="id"
                    ref="dataTable"
                    size="mini"
                    stripe
                    :data="tableData"
                    v-loading="loading"
                    @selection-change="handleSelectionChange"
                    :height="tableConfig.height"
                    style="width: 100%">
                    <el-table-column type="selection" width="55" align="center" fixed/>
                    <el-table-column class-name="drag"
                                     width="auto"
                                     min-width="220"
                                     v-if="dropCol[0].isShow"
                                     :key="dropCol[0].id"
                                     :prop="dropCol[0].prop"
                                     :label="dropCol[0].label" >
                    </el-table-column>
                    <el-table-column class-name="drag"
                                     width="auto"
                                     min-width="150"
                                     v-if="dropCol[1].isShow"
                                     :key="dropCol[1].id"
                                     :prop="dropCol[1].prop"
                                     :label="dropCol[1].label" >
                    </el-table-column>
                    <el-table-column width="auto"
                                     min-width="300"
                                     class-name="drag"
                                     v-if="dropCol[2].isShow"
                                     :key="dropCol[2].id"
                                     :prop="dropCol[2].prop"
                                     :label="dropCol[2].label"/>
                    <el-table-column class-name="drag"
                                     width="auto"
                                     min-width="120"
                                     v-if="dropCol[3].isShow"
                                     :key="dropCol[3].id"
                                     :prop="dropCol[3].prop"
                                     :label="dropCol[3].label"
                                     align="right"/>
                    <el-table-column width="auto"
                                     class-name="drag"
                                     v-if="dropCol[4].isShow"
                                     :key="dropCol[4].id"
                                     :prop="dropCol[4].prop"
                                     :label="dropCol[4].label"
                                      min-width="120"
                                      align="right"/>
                    <el-table-column width="auto"
                                     class-name="drag"
                                     v-if="dropCol[5].isShow"
                                     :key="dropCol[5].id"
                                     :prop="dropCol[5].prop"
                                     :label="dropCol[5].label"
                                     min-width="120"
                                     align="right"/>
                    <el-table-column width="auto"
                                     class-name="drag"
                                     v-if="dropCol[6].isShow"
                                     :key="dropCol[6].id"
                                     :prop="dropCol[6].prop"
                                     :label="dropCol[6].label"
                                     min-width="120"
                                     align="right"/>
                    <el-table-column width="auto"
                                     class-name="drag"
                                     v-if="dropCol[7].isShow"
                                     :key="dropCol[7].id"
                                     :prop="dropCol[7].prop"
                                     :label="dropCol[7].label"
                                     min-width="120"
                                     align="right"/>
                    <el-table-column width="auto"
                                     class-name="drag"
                                     v-if="dropCol[8].isShow"
                                     :key="dropCol[8].id"
                                     :prop="dropCol[8].prop"
                                     :label="dropCol[8].label"
                                     min-width="200"/>
                    <el-table-column width="auto"
                                     class-name="drag"
                                     v-if="dropCol[9].isShow"
                                     :key="dropCol[9].id"
                                     :prop="dropCol[9].prop"
                                     :label="dropCol[9].label"
                                     min-width="200"/>
                    <el-table-column width="auto"
                                     class-name="drag"
                                     v-if="dropCol[10].isShow"
                                     :key="dropCol[10].id"
                                     :prop="dropCol[10].prop"
                                     :label="dropCol[10].label"
                                     min-width="120"
                                     align="right"/>
                    <el-table-column width="auto"
                                     fixed="right"
                                     class-name="drag"
                                     v-if="dropCol[11].isShow"
                                     :key="dropCol[11].id"
                                     :prop="dropCol[11].prop"
                                     :label="dropCol[11].label"
                                     min-width="150"
                                     align="right">
                    <!-- <el-table-column width="100" align="center" fixed="right"
                                     v-if="dropCol[12].isShow"
                                     :key="dropCol[12].id"
                                     :prop="dropCol[12].prop"
                                     :label="dropCol[12].label"> -->
                        <template slot="header"  slot-scope="header">
                            <el-dropdown style="margin-left: 8px;" @command="more">
                                <el-button type="primary" size="mini">
                                    操作<i class="el-icon-arrow-down el-icon--right"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item command="exportReceipt">导出签收单</el-dropdown-item>
                                    <!-- <el-dropdown-item command="exportErpBidOrder">导出中标</el-dropdown-item>
                                    <el-dropdown-item command="exportErpPO">导出反签</el-dropdown-item>
                                    <el-dropdown-item command="exportErpMaterial">导出物料</el-dropdown-item>
                                    <el-dropdown-item command="exportErpInboundOrder" divided>导出入库单</el-dropdown-item>
                                    <el-dropdown-item command="exportErpOutboundOrder">导出出库单</el-dropdown-item>
                                    <el-dropdown-item command="exportErpSubmitInvoice">导出交票单</el-dropdown-item>
                                    <el-dropdown-item command="exportErpSettlement">导出结算单</el-dropdown-item>
                                    <el-dropdown-item command="exportFinanceInvoiceDetail" divided>导出开票明细</el-dropdown-item>
                                    <el-dropdown-item command="exportFinanceMoney" divided>导出提报付款</el-dropdown-item> -->
                                </el-dropdown-menu>
                            </el-dropdown>
                        </template>
                        <template slot-scope="scope">
                            <span>{{ scope.row.createTime }}</span>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="text-align: center;padding-top: 20px" v-if="total > 0">
                    <el-pagination
                        background
                        layout="sizes,prev, pager, next"
                        :total="total"
                        :page-sizes="[10, 20, 50, 100, 500, 1000]"
                        :page-size="pageSize"
                        @size-change="onSizeChange"
                        @current-change="onPageChange"
                        :current-page="currentPage"
                        @prev-click="onPageChange"
                        @next-click="onPageChange">
                    </el-pagination>
                </div>
            </el-card>
        </main>

    </div>
</template>
<script>
import Sortable from 'sortablejs'//引入插件
import { downloadByPost, convertRes2Blob } from '../../utils/download.js';
import { KeepAliveTableMixins } from '../../mixin/KeepAliveTable.js';
const HEIGHT_OFFSET = 118;
import RightToolBar from "../../components/RightToolBar";

export default {
    mixins: [KeepAliveTableMixins],
    components:{RightToolBar},
    data() {
        return {

            showSearch:false,
            updateTable:"productsTable",
            dropCol:[
                {id:"0",label:'公司名称',prop:'companyName',isShow:true},
                {id:"1",label:'SKU',prop:'sku',isShow:true},
                {id:"2",label:'商品名称',prop:'productName',isShow:true},
                {id:"3",label:'销售数量',prop:'num',isShow:true},
                {id:"4",label:'未税单价(元)',prop:'untaxedPrice',isShow:true},
                {id:"5",label:'含税单价(元)',prop:'price',isShow:true},
                {id:"6",label:'未税总价(元)',prop:'totalUntaxedPrice',isShow:true},
                {id:"7",label:'含税总价(元)',prop:'totalPrice',isShow:true},
                {id:"8",label:'销售订单编号',prop:'settlementNo',isShow:true},
                {id:"9",label:'订单编号',prop:'orderNo',isShow:true},
                {id:"10",label:'收货人',prop:'consignee',isShow:true},
                {id:"11",label:'创建时间',prop:'createTime',isShow:true},
                // {id:"12",label:'状态',prop:'showStatus',isShow:true},
            ],
            //table所有的表头数据
            allTableLabel:[],
            pageLoading: undefined,
            tableConfig: {
                height: 0,
            },
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
            },
            companys:[],
            money: 0,
            invoiceList:[],
            addressList:[],
            reviewVisible:false,
            searchForm: {
                companyId: "",
                settlementNo: "",
                orderNo: "",
                sku: "",
                status: [],
            },
            searchFormExport: {},
            loading: false,
            total: 0,
            pageSize: 10,
            currentPage: 1,
            tableData: [],

            addOrderForm: {
                id: "",
                orderBatch: "",
            },
            exportOrderVisible: false,
            exportOrderForm: {
                orderBatch: "",
            },
            orderForm: {
                orderBatch: "",
            },
            reviewForm: {
                id:"",
                companyId:"",
                invoiceId:"",
                companyName:"",//
                bankName:"",//
                bankAccount:"",//
                companyTaxNo:"",//
                registeredTel:"",//
                registeredAddress:"",//

            },
            addressId:"",
            addressForm: {
                region: {
                    province: '',
                    city: '',
                    area: '',
                    town:""
                },
                id:"",
                mobile:"",
                address:"",//
                consignee:"",//
                county:"",//
                city:"",//
                province:"",//
                provinceId:"",//
                cityId:"",//
                countyId:""//
            },
            selectData:[],//选中的数据
            rules: {
                address: [
                    { required: true, message: '请输入详细地址', trigger: 'blur' }
                ],
                consignee: [
                    { required: true, message: '请输入收件人', trigger: 'blur' }
                ],
                mobile: [
                    { required: true, message: '请输入联系电话', trigger: 'blur' }
                ],

            },
        }
    },

    methods: {
        //重绘表格
        reDrawTable() {

            this.updateTable = "productsTable"+Math.random();
            this.$nextTick(()=>{

                this.columnDrop();
            });

        },

        doSearch() {
            this.currentPage=1;
            this.onSearch();
        },
        onSearch() {

            this.loading = true;
            // this.selectData = [];
            // let _this = this;
            // let cond = {...this.searchForm};
            const that = this;
            this.$axios.post("/admin/product/order/pageSignForProducts",{
                cond: this.searchForm,
                page: this.currentPage - 1,size:this.pageSize
            }).then(function(response) {
                let resp = response.data;
                if( resp.header.status == 0) {
                    that.tableData = resp.data.content;
                    that.total = resp.data.totalElements;
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        onPageChange(currentPage) {
            this.currentPage = currentPage;
            this.onSearch();
        },
        onSizeChange(val) {
            this.pageSize = val;
            this.onSearch();
        },
        more(command){
            if(command && command.length > 6 && command.substr(0,6)==="export") {
                if (this.selectData.length == 0) {
                    this.$message({
                        type: 'error',
                        message: '请选择要导出的订单',
                        duration: 2000
                    });
                    return;
                }
                const ids = this.selectData.map(it => it["id"]);
                this.pageLoading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                downloadByPost({
                    axios: this.$axios,
                    url: `/admin/order/${command}`,
                    data: ids,
                    success: response => {
                        convertRes2Blob(response);
                    },
                    faild: () => {
                        this.$message({
                            type: 'error',
                            message: '导出失败',
                            duration: 2000
                        });
                    },
                    complete: () => {
                        this.pageLoading.close();
                        this.pageLoading = undefined;
                    }
                });
            }
        },
        andleSelectionChange(val) {
            this.selectData = val;
        },
        handleToDeliver(row) {
            this.viewDeliverVisible = true;
            this.$router.push({name: "saleOrderDeliver", params: {from: "order", orderId: row.id}});
        },
        setTableHeight() {
            const tablePosition = this.$refs['tablePosition'];
            const {top} = tablePosition.getBoundingClientRect();
            this.tableConfig.height = window.innerHeight - top - HEIGHT_OFFSET;
        },
        handleSelectionChange(val) {
            this.selectData = val;
        },
        loadCompanys(){
            let _this = this
            this.$axios.post("/admin/company/customerCompanies"
            ).then(function (response) {
                let resp = response.data;
                if (resp.header.status == 0) {
                    _this.companys = resp.data;
                }
            });

        },
        //列拖拽
        columnDrop(){
            try{
            //const wrapperTr = this.$refs.dataTable.$el.querySelector('.el-table__header-wrapper tr');
            const wrapperTr = document.querySelector('.el-table__header-wrapper tr');
            let oldLabel;
            let newLabel;
            let oldIndex;
            let newIndex;
            let count=0;
            const that=this;
            this.sortable = Sortable.create(wrapperTr, {
                animation: 180,
                delay: 30,
                draggable:".drag",
                onEnd: evt => {
                          oldLabel=this.$refs.dataTable.columns[evt.oldIndex].property;
                          newLabel=this.$refs.dataTable.columns[evt.newIndex].property;
                          for (let i=0;i<that.dropCol.length;i++){
                              if (that.dropCol[i].prop!=undefined&&that.dropCol[i].prop==newLabel)
                                  newIndex=i;

                          }

                          for (let j=0;j<that.dropCol.length;j++){
                              if (that.dropCol[j].prop!=undefined&&that.dropCol[j].prop==oldLabel)
                                  oldIndex=j;
                          }

                          const oldItem = this.dropCol[oldIndex];
                          this.dropCol.splice(oldIndex, 1);
                          this.dropCol.splice(newIndex, 0, oldItem);

                          this.dropCol.forEach((item)=>{
                              if(item.prop==newLabel||item.prop==oldLabel){
                                  item.id=new Date().getTime() + (++count)+"";
                                  //console.log(JSON.stringify(this.dropCol));// eslint-disable-line
                              }
                          })



                },
            });
            }catch (e) {
                console.log(e);// eslint-disable-line
            }
        },


    },
    mounted() {
        this.pageLoading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
            this.setTableHeight();
            this.pageLoading.close();
            this.pageLoading = undefined;
        }, 500);


        this.columnDrop();

    },
    beforeDestroy() {
        if(this.pageLoading){
            this.pageLoading.close();
            this.pageLoading = undefined;
        }
    },
    destroyed () {
        window.removeEventListener("resize", this.setTableHeight);
    },
    created() {
        this.onSearch();
        this.loadCompanys();
        //this.setTableShow();
        window.addEventListener("resize", this.setTableHeight);
    }
}
</script>
<style>
    .el-table th.gutter{

        display: table-cell!important;

    }
    .item {

        margin-bottom: 0px;

    }
    .item1 {
        margin-top: -10px;
        margin-bottom: 0px;

    }
    ::v-deep .el-table__body .el-table__row:nth-child(n) td {
        background-color: #fff !important;
    }
</style>